var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSearchNormal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 18.3334L16.6667 16.6667M17.5 9.58342C17.5 13.9557 13.9556 17.5001 9.58335 17.5001C5.2111 17.5001 1.66669 13.9557 1.66669 9.58342C1.66669 5.21116 5.2111 1.66675 9.58335 1.66675C13.9556 1.66675 17.5 5.21116 17.5 9.58342Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSearchNormal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-search-normal.fdfc4c2e23b313ec5c6b247decd2fd4f.svg";